// Breadcrumbs.js

import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(segment => segment.trim() !== '');

    return (
        <nav aria-label="Breadcrumb" className="breadcrumbs">
            <ul className='breadcrumbs-list'>
                <li>
                    <Link to="/"><i className="fa-solid fa-house-chimney"></i></Link>
                </li>

                {pathSegments.map((segment, index) => {
                    return (
                        <li key={segment}>
                            <Link to={`/${pathSegments.slice(0, index + 1).join('/')}`}>{segment.replace(/-/g, ' ')}</Link>
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

export default Breadcrumbs;